import './app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PointsCacheProvider } from './contexts/points-cache-context';
import UserSettingsProvider from './contexts/user-settings-context';

// const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
// const locale = import.meta.env.APP_LOCALE || 'sv';
// const fallbackLocale = import.meta.env.APP_FALLBACKLOCALE || 'en';

createInertiaApp({
    resolve: (name) => {
        const page = resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx')
        );

        return page.then((mod: any) => {
            const Component = mod.default;
            if (!Component.layout) {
                Component.layout = (pageEl: React.ReactNode) => (
                    <StrictMode>
                        <UserSettingsProvider>
                            <PointsCacheProvider>
                                {pageEl}
                            </PointsCacheProvider>
                        </UserSettingsProvider>
                    </StrictMode>
                );
            }
            return mod;
        });
    },
    setup({ el, App, props }) {
        createRoot(el).render(<App {...props} />);
    },
    progress: { color: '#4B5563' },
});

// Register the root Service Worker for PWA installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Optional: ignore registration errors to avoid runtime crashes
    });
  });
}
